"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplaceVTOForm = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const components_1 = require("../../../components");
const Flex_1 = require("@amzn/atoz-web/Flex");
const View_1 = require("@amzn/atoz-web/View");
const luxon_1 = require("luxon");
const Text_1 = require("@amzn/atoz-web/Text");
const Spacer_1 = require("@amzn/atoz-web/Spacer");
const context_1 = require("../../../components/ReplaceVTOWorkflow/context");
const hooks_1 = require("../../../hooks");
const consts_1 = require("../../../consts");
const utils_1 = require("../../../components/ReplaceVTOWorkflow/utils");
const Checkbox_1 = require("@amzn/atoz-web/Checkbox");
const Col_1 = require("@amzn/atoz-web/Col");
const Row_1 = require("@amzn/atoz-web/Row");
const useGetPaycodes_1 = require("../../../hooks/useGetPaycodes/useGetPaycodes");
const logger_1 = require("../../../logger");
const utils_2 = require("../../../utils");
const MessageBanner_1 = require("@amzn/atoz-web/MessageBanner");
const ReplaceVTOForm = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { associateInfo, isChecked, setIsChecked, vtoSummary, setVTOSummary, isSubmitDisabled, setIsSubmitDisabled } = (0, context_1.useReplaceVTOWorkflowContext)();
    const [currentPTOBalance, setCurrentPTOBalance] = (0, react_1.useState)();
    const [updatedPTOBalance, setUpdatedPTOBalance] = (0, react_1.useState)();
    const [isCheckboxDisabled, setIsCheckboxDisabled] = (0, react_1.useState)([]);
    const [isBannerEnabled, setIsBannerEnabled] = (0, react_1.useState)(false);
    const [dateAsOfNow, setIsDateAsOfNow] = (0, react_1.useState)(luxon_1.DateTime.utc().toFormat(utils_1.DATE_TIME_FORMAT.DATETIME_IN_ISO));
    const [startTimePayPeriod, setStartTimePayPeriod] = (0, react_1.useState)();
    const usageLocation = consts_1.featureNames.REPLACE_VTO_WORKFLOW_FEATURE;
    const { isLoading: isBalancesLoading, data: balancesResponse } = (0, hooks_1.useTimeAwayBalances)({
        employeeId: associateInfo.employeeId,
        targetDateTime: dateAsOfNow,
        usageLocation,
        shouldFetch: true
    });
    const { data: { pay_period_breakdown_info } = {} } = (0, hooks_1.usePayPeriod)({
        employeeId: associateInfo.employeeId,
        shouldFetch: true,
        usageLocation: usageLocation
    });
    (0, react_1.useEffect)(() => {
        if (isBalancesLoading)
            return;
        const ptoBalance = (0, utils_1.getPTOBalance)(balancesResponse === null || balancesResponse === void 0 ? void 0 : balancesResponse.balances);
        if (balancesResponse && currentPTOBalance != ptoBalance) {
            setCurrentPTOBalance(ptoBalance);
            setUpdatedPTOBalance(ptoBalance);
        }
    }, [balancesResponse]);
    (0, react_1.useEffect)(() => {
        if (currentPTOBalance <= 0) {
            setIsSubmitDisabled(true);
        }
    }, [currentPTOBalance]);
    (0, react_1.useEffect)(() => {
        if (updatedPTOBalance <= 0) {
            setIsSubmitDisabled(true);
        }
        else if (updatedPTOBalance > 0 && currentPTOBalance > 0) {
            setIsSubmitDisabled(false);
        }
        else {
            setIsSubmitDisabled(isSubmitDisabled);
        }
    }, [updatedPTOBalance]);
    const { isLoading: isPayCodesLoading, data: paycodes_list } = (0, useGetPaycodes_1.useGetPaycodes)({
        employeeId: associateInfo.employeeId,
        startDateTime: luxon_1.DateTime.fromISO(dateAsOfNow)
            .minus({ weeks: 2 })
            .toISODate()
            .toString(),
        endDateTime: dateAsOfNow,
        useV4Api: 'true'
    });
    (0, react_1.useEffect)(() => {
        if (!isPayCodesLoading && paycodes_list) {
            const vtoSummary = (0, utils_1.getSummaryFromPaycodes)(paycodes_list, associateInfo.timeZone, components_1.VTOPaycode.US_VTO);
            setVTOSummary(vtoSummary);
            setIsChecked(Array(vtoSummary.length).fill(false));
            setIsCheckboxDisabled(Array(vtoSummary.length).fill(false));
            const ptoSummary = (0, utils_1.getSummaryFromPaycodes)(paycodes_list, associateInfo.timeZone, components_1.PTOPaycode.Personal_Time_Off);
            ptoSummary.forEach((pto) => {
                vtoSummary.forEach((vto, index) => {
                    if (vto.startDate == pto.startDate &&
                        vto.startTime == pto.startTime) {
                        setIsCheckboxDisabled([
                            ...isCheckboxDisabled.slice(0, index - 1),
                            true,
                            ...isCheckboxDisabled.slice(index)
                        ]);
                        setIsBannerEnabled(true);
                    }
                });
            });
        }
    }, [paycodes_list]);
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.REPLACE_VTO_FORM_RENDERED.COUNT
        },
        isComponentLoaded: true
    });
    (0, react_1.useEffect)(() => {
        utils_2.BIAnalytics.arriveInReplaceVTOForm();
    }, []);
    return (react_1.default.createElement(components_1.SpinnerOverlay, { isLoading: false },
        react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column' },
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', margin: { top: 'S300' }, gridGap: 'S200', flexWrap: 'wrap' },
                react_1.default.createElement(Text_1.Text, { color: parseInt((0, components_1.getHoursAndMinutesFromDuration)((0, utils_1.convertDurationInHours)(currentPTOBalance))) <= 0
                        ? 'red'
                        : 'black' }, t('time_and_attendance_current_pto_balance_title', {
                    currentPTO: (0, components_1.getHoursAndMinutesFromDuration)((0, utils_1.convertDurationInHours)(currentPTOBalance))
                }))),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', dataTestId: components_1.REPLACE_VTO_WF_DATA_TEST_IDS.REPLACE_VTO_WF_VTO_SUMMARY, gridGap: 'S300', margin: { top: 'S300' } },
                react_1.default.createElement(Text_1.Label, { fontWeight: 'regular' }, t('')),
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', alignItems: 'left', gridGap: 'S900' },
                    isBannerEnabled && (react_1.default.createElement(View_1.View, null,
                        react_1.default.createElement(MessageBanner_1.MessageBanner, null, t('time_and_attendance_replce_vto_banner_message')),
                        react_1.default.createElement(Spacer_1.Spacer, { height: 'S300' }))),
                    vtoSummary.map((vto, index) => {
                        return (react_1.default.createElement(Col_1.Col, { key: index, alignItems: 'left', gridGap: 'S900' },
                            react_1.default.createElement(Row_1.Row, { style: { marginBottom: '1rem' } },
                                react_1.default.createElement(Checkbox_1.Checkbox, { disabled: isCheckboxDisabled[index], onClick: (e) => {
                                        const checkedState = !isChecked[index];
                                        setIsChecked([
                                            ...isChecked.slice(0, index),
                                            checkedState,
                                            ...isChecked.slice(index + 1)
                                        ]);
                                        if (checkedState) {
                                            setUpdatedPTOBalance(updatedPTOBalance - vto.duration);
                                        }
                                        else {
                                            setUpdatedPTOBalance(updatedPTOBalance + vto.duration);
                                        }
                                    }, dataTestId: 'VTOCheckbox', id: index.toString(), checked: isChecked[index], style: { display: 'initial' } }),
                                react_1.default.createElement(Spacer_1.Spacer, { width: 'S300' }),
                                react_1.default.createElement(Text_1.Label, { htmlFor: index.toString() }, t('time_and_attendance_replace_vto_checkbox_title', {
                                    startDate: vto.startDate,
                                    startTime: vto.startTime,
                                    duration: `${(0, components_1.getHoursAndMinutesFromDuration)((0, utils_1.convertDurationInHours)(vto.duration))}`
                                })))));
                    }))),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', gridGap: 'S300', margin: { top: 'S300' } },
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', gridGap: 'S200' },
                    react_1.default.createElement(View_1.View, { className: "atoz-filter-text-time-input", flexGrow: 1 },
                        react_1.default.createElement(Text_1.Text, { color: parseInt((0, components_1.getHoursAndMinutesFromDuration)((0, utils_1.convertDurationInHours)(updatedPTOBalance))) <= 0
                                ? utils_1.FONT_COLOR.STENCIL_RED
                                : '' }, t('time_and_attendance_updated_pto_balance_title', {
                            updatedPTO: (0, components_1.getHoursAndMinutesFromDuration)((0, utils_1.convertDurationInHours)(updatedPTOBalance))
                        }))))),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', dataTestId: components_1.REPLACE_VTO_WF_DATA_TEST_IDS.REPLACE_VTO_FINAL_WARNING, gridGap: 'S300', margin: { top: 'S500' } },
                react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row', gridGap: 'S200' },
                    react_1.default.createElement(View_1.View, { flexGrow: 1 },
                        react_1.default.createElement(Text_1.P, null, t('time_and_attendance_replace_vto_summary_warning'))))))));
};
exports.ReplaceVTOForm = ReplaceVTOForm;
